import React from "react";
import styles from "./ProjectCard.module.css";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";
const ProjectCard = ({ image, title, about, links, tech }) => {
  const { mode } = React.useContext(ThemeContext);
  let [src, alt] = image;
  console.log("object");
  let [git, demo] = links;
  const handleGit = () => {
    window.open(git);
  };
  const handleVideo = () => {
    window.open(demo);
  };
  let str = "";
  for (let i = 0; i < tech.length; i++) {
    str += tech[i] + ",  ";
  }
  return (
    <div
      className={styles.container}
      style={
        mode === "dark"
          ? { background: "rgb(35,35,35)", boxShadow: "none", border: "none" }
          : { background: "#fff" }
      }
    >
      <div
        className={styles.title}
        style={mode === "dark" ? { color: "#fff" } : { color: "rgb(35,35,35)" }}
      >
        {title}
      </div>
      <div className={styles.images}>
        <img src={src} alt={alt} />
      </div>
      <div
        className={styles.about}
        style={mode === "dark" ? { color: "#fff" } : { color: "rgb(35,35,35)" }}
      >
        {about}
      </div>
      <div className={styles.techContainer}>
        <h3
          className={styles.techHeading}
          style={
            mode === "dark" ? { color: "#fff" } : { color: "rgb(35,35,35)" }
          }
        >
          Tech Stack :
        </h3>
        <p
          className={styles.techStack}
          style={
            mode === "dark" ? { color: "#fff" } : { color: "rgb(35,35,35)" }
          }
        >
          {str}
        </p>
      </div>
      <div className={styles.links}>
        {/* <FaGithub size="2.1em" /> */}
        <div
          classname={styles.buttons}
          style={
            mode === "dark" ? { color: "#fff" } : { color: "rgb(35,35,35)" }
          }
          onClick={handleGit}
        >
          Code
        </div>
        <div
          onClick={handleVideo}
          style={
            mode === "dark" ? { color: "#fff" } : { color: "rgb(35,35,35)" }
          }
          classname={styles.buttons}
        >
          Live Demo
        </div>
        {/* <FaPlayCircle onClick={handleVideo} size="2.1em" /> */}
      </div>
    </div>
  );
};

export default ProjectCard;
